import React, { useEffect } from "react";
import { View, TouchableOpacity, StyleSheet } from "react-native";
import { createStackNavigator } from "@react-navigation/stack";
import OtherListView from "../../views/Other/ListView/ListView";
import ParkingMapView from "../../views/Parking/ParkingMapView";
import ImageGalleryModal from "../ImageGalleryModal/ImageGalleryModal";
import { STRINGS, COLORS } from "../../constants";
import ParkingDetailsView from "../../views/Parking/DetailsView/ParkingDetailsView";
import { Platform } from "react-native";
import ParkingStore from "../../storage/parkingStore";
import { HeaderBackButton } from "@react-navigation/elements";
import { faGauge, faBuilding } from "@fortawesome/free-solid-svg-icons";

const FontAwesomeIcon =
  Platform.OS === "web"
    ? require("@fortawesome/react-fontawesome").FontAwesomeIcon
    : require("@fortawesome/react-native-fontawesome").FontAwesomeIcon;

const iconSize = Platform.OS === "web" ? "lg" : 16;

const Stack = createStackNavigator();

/**
 * ParkingStack Component
 *
 * Defines the stack navigator for the Parking feature.
 * Includes a ListView for parking options and a MapView for location visualization.
 */
const ParkingStack = () => {
  const fetchParking = ParkingStore((state) => state.fetchParking);
  const showMeter = ParkingStore((state) => state.showMeter);
  const showStructure = ParkingStore((state) => state.showStructure);
  const toggleMeter = ParkingStore((state) => state.toggleMeter);
  const toggleStructure = ParkingStore((state) => state.toggleStructure);

  const ParkingToggles = () => {
    return (
      <View style={styles.parkingTogglesContainer}>
        <TouchableOpacity
          onPress={toggleMeter}
          accessibilityLabel={`${STRINGS.parkingMeters} ${showMeter ? "on" : "off"}`}
          style={{ ...styles.iconCircle, ...{ backgroundColor: showMeter ? COLORS.primary : COLORS.border } }}
        >
          <FontAwesomeIcon icon={faGauge} size={iconSize} color={COLORS.textLight} />
        </TouchableOpacity>
        <TouchableOpacity
          onPress={toggleStructure}
          accessibilityLabel={`${STRINGS.parkingStructures} ${showStructure ? "on" : "off"}`}
          style={{ ...styles.iconCircle, ...{ backgroundColor: showStructure ? COLORS.primary : COLORS.border } }}
        >
          <FontAwesomeIcon icon={faBuilding} size={iconSize} color={COLORS.textLight} />
        </TouchableOpacity>
      </View>
    );
  };

  useEffect(() => {
    fetchParking();
  }, []);

  return (
    <Stack.Navigator
      initialRouteName="ParkingListView"
      screenOptions={{
        cardStyle: { flex: 1 },
      }}
    >
      {/* Parking ListView */}
      <Stack.Screen
        name="ParkingListView"
        options={{
          title: STRINGS.parkingTitle,
          headerRight: () => <ParkingToggles />,
        }}
      >
        {() => <OtherListView type="parking" />}
      </Stack.Screen>

      {/* Parking MapView */}
      <Stack.Screen
        name="ParkingMapView"
        component={ParkingMapView}
        options={{
          title: STRINGS.parkingTitle,
          headerLeft: () => null,
          headerRight: () => <ParkingToggles />,
        }}
      />
      {/* DetailsView Screen - Provides details about the parking */}
      <Stack.Screen
        name="ParkingDetailsView"
        component={ParkingDetailsView}
        options={({ navigation }) => {
          const canGoBack = navigation.canGoBack();
          const hideNavigationBar = Platform.OS === "android" && !canGoBack ? { headerShown: false } : {};

          return {
            ...hideNavigationBar,
            headerBackTitle: STRINGS.back,
            ...(Platform.OS === "web" && !canGoBack
              ? {
                  headerLeft: () => (
                    <HeaderBackButton
                      tintColor="#000"
                      onPress={() => {
                        window.location.href = `${window.location.origin}/parking`;
                      }}
                    />
                  ),
                }
              : {}),
          };
        }}
      />
      <Stack.Screen
        name="ImageGalleryModal"
        component={ImageGalleryModal}
        options={{ presentation: "modal", headerShown: false }}
      />
    </Stack.Navigator>
  );
};
export default ParkingStack;

const styles = StyleSheet.create({
  parkingTogglesContainer: {
    flexDirection: "row",
    gap: Platform.OS === "ios" ? 8 : 14,
    marginRight: 18,
  },
  iconCircle: {
    width: Platform.OS === "web" ? 40 : 32,
    height: Platform.OS === "web" ? 40 : 32,
    borderRadius: 20,
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.6,
    shadowRadius: 12,
    elevation: 8,
    backgroundColor: "white",
  },
});
